import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignments: { loading: false, data: [], error: null },
  completions: { loading: false, data: [], error: null },
  rules: { loading: false, data: [], error: null },
  siteReadiness: { loading: false, data: null, error: null },
  gaps: { loading: false, data: [], error: null },
  providerHealth: { loading: false, data: null, error: null },
  catalog: { loading: false, data: [], error: null },
};

const trainingSlice = createSlice({
  name: "afmsTraining",
  initialState,
  reducers: {
    assignmentsStart: (state) => { state.assignments.loading = true; state.assignments.error = null; },
    assignmentsSuccess: (state, action) => { state.assignments.loading = false; state.assignments.data = action.payload; },
    assignmentsFailure: (state, action) => { state.assignments.loading = false; state.assignments.error = action.payload; },

    completionsStart: (state) => { state.completions.loading = true; state.completions.error = null; },
    completionsSuccess: (state, action) => { state.completions.loading = false; state.completions.data = action.payload; },
    completionsFailure: (state, action) => { state.completions.loading = false; state.completions.error = action.payload; },

    rulesStart: (state) => { state.rules.loading = true; state.rules.error = null; },
    rulesSuccess: (state, action) => { state.rules.loading = false; state.rules.data = action.payload; },
    rulesFailure: (state, action) => { state.rules.loading = false; state.rules.error = action.payload; },

    siteReadinessStart: (state) => { state.siteReadiness.loading = true; state.siteReadiness.error = null; },
    siteReadinessSuccess: (state, action) => { state.siteReadiness.loading = false; state.siteReadiness.data = action.payload; },
    siteReadinessFailure: (state, action) => { state.siteReadiness.loading = false; state.siteReadiness.error = action.payload; },

    gapsStart: (state) => { state.gaps.loading = true; state.gaps.error = null; },
    gapsSuccess: (state, action) => { state.gaps.loading = false; state.gaps.data = action.payload; },
    gapsFailure: (state, action) => { state.gaps.loading = false; state.gaps.error = action.payload; },

    providerHealthStart: (state) => { state.providerHealth.loading = true; state.providerHealth.error = null; },
    providerHealthSuccess: (state, action) => { state.providerHealth.loading = false; state.providerHealth.data = action.payload; },
    providerHealthFailure: (state, action) => { state.providerHealth.loading = false; state.providerHealth.error = action.payload; },

    catalogStart: (state) => { state.catalog.loading = true; state.catalog.error = null; },
    catalogSuccess: (state, action) => { state.catalog.loading = false; state.catalog.data = action.payload; },
    catalogFailure: (state, action) => { state.catalog.loading = false; state.catalog.error = action.payload; },
  },
});

export const {
  assignmentsStart, assignmentsSuccess, assignmentsFailure,
  completionsStart, completionsSuccess, completionsFailure,
  rulesStart, rulesSuccess, rulesFailure,
  siteReadinessStart, siteReadinessSuccess, siteReadinessFailure,
  gapsStart, gapsSuccess, gapsFailure,
  providerHealthStart, providerHealthSuccess, providerHealthFailure,
  catalogStart, catalogSuccess, catalogFailure,
} = trainingSlice.actions;

export default trainingSlice.reducer;
